import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
const _excluded = ["chevronDirection", "children", "className", "fgColor", "flexHeight", "iconName", "noBorder", "to", "trackId", "buttonRef"];
// @ts-nocheck
import React from 'react';
import classnames from 'classnames';
import { Chevron } from '@latitude/chevron';
import { Link } from '@latitude/link';
import SvgInline from '@latitude/svg-inline';
import './_link-block.scss';
const LinkBlock = props => {
  const {
      chevronDirection,
      children,
      className,
      fgColor,
      flexHeight,
      iconName,
      noBorder,
      to,
      trackId,
      buttonRef
    } = props,
    otherProps = _objectWithoutProperties(props, _excluded);
  const svgColAttrs = {};
  if (iconName) {
    if (fgColor === 'blue') {
      svgColAttrs.strokeBlueBright = true;
      svgColAttrs.fillBlueBright = true;
    } else if (fgColor === 'white') {
      svgColAttrs.strokeWhite = true;
      svgColAttrs.fillWhite = true;
    }
  }
  const Inner = /*#__PURE__*/React.createElement(React.Fragment, null, iconName && /*#__PURE__*/React.createElement("div", {
    className: "link-block__icon"
  }, /*#__PURE__*/React.createElement(SvgInline, Object.assign({
    name: iconName,
    className: "h-100 mr-3 w-auto"
  }, svgColAttrs))), children, /*#__PURE__*/React.createElement("div", {
    className: "link-block__chevron ml-auto"
  }, /*#__PURE__*/React.createElement(Chevron, {
    direction: chevronDirection,
    strokeBlueBright: fgColor === 'blue',
    strokeWhite: fgColor === 'white'
  })));
  const classes = classnames('link-block', 'd-flex', 'w-100', 'text-left', 'align-items-center', iconName && 'link-block--icon', noBorder && 'link-block--no-border', fgColor !== LinkBlock.defaultProps.fgColor && `link-block--text-${fgColor}`, flexHeight && 'link-block--flex-height', className);
  return to ? /*#__PURE__*/React.createElement(Link, Object.assign({
    href: to,
    trackId: trackId,
    noStyle: true,
    className: classes
  }, otherProps), Inner) : /*#__PURE__*/React.createElement("button", Object.assign({
    ref: buttonRef,
    className: classes,
    type: "button"
  }, otherProps), Inner);
};
LinkBlock.defaultProps = {
  fgColor: 'grey-dark',
  chevronDirection: 'right'
};
export default LinkBlock;